import React, { useState, useEffect } from 'react';
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import moment from 'moment';
import DataTable from 'react-data-table-component';

export default function PopUpTable({ show, handleClose, apiprops, convertedMonth, gloablfilter }) {

  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [monthWiseData, setMonthWiseData] = useState([]);

  useEffect(() => {
    if (convertedMonth !== undefined) {
      fetchData(
        {
          url: API_URL_MAIN + "trend_analysis_drive_bus/getmonthWiseRange",
          body: {
            filterdata: {
              "CITY": gloablfilter.CITY,
              "DEPO": gloablfilter.DEPO,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "endDate": convertedMonth[1],
              "pageSelected": 1,
              "startDate": convertedMonth[0],
              "AIR_VENTILATION": "",
            }
          },
        },
        responceMonthWiseData
      );
    }

  }, [convertedMonth]);

  const responceMonthWiseData = (data) => {
    setMonthWiseData(data);
  }

  const columns = [
    { name: 'Vin No.', selector: (row) => row.key.vehicleId, width: '25%', center: true },
    { name: 'Reg No.', selector: (row) => row.key.vehicle_registration_number, width: '20%', center: true },
    { name: 'City', selector: (row) => row.key.DLR_ORG_CITY, width: '20%', center: true },
    { name: 'Depot', selector: (row) => row.key.Depot_Name, width: '20%', center: true },
    { name: 'Range', selector: (row) => row.median_Range.values["50.0"].toFixed(2), width: '15%', center: true }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <div style={{ width: "500px" }}>
      <div className={`modal ${show ? 'show' : ''}`} tabIndex="-1" role='dialog' style={{ display: show ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Lowest 5 median range buses in this month.</h5>
              <button type="button" className="close" onClick={handleClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <DataTable
                columns={columns}
                data={monthWiseData}
                customStyles={customStyles}
                fixedHeader={true}
              // fixedHeaderScrollHeight='280px'
              />
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </div>
  )
}
